import type { RequestPayload } from "@inertiajs/core";
import { usePage } from "@inertiajs/react";
import { Divider, Fieldset, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import type { Coach } from "../../models/coach";
import { SaveButton } from "../button/SaveButton";
import { ParticularsForm, type ParticularsFormErrorType, type ParticularsFormType } from "../particularsForm/ParticularsForm";
import { UserForm, type UserFormErrorTypes, type UserFormType } from "../user/UserForm";

type AdminFormProps = {
  admin?: Coach;
  onSubmit: (values: RequestPayload) => void;
  submitButtonLabel: string;
};

type FormErrors = UserFormErrorTypes & ParticularsFormErrorType;

type AdminFormType = UserFormType & ParticularsFormType;

export function AdminForm({ admin, onSubmit, submitButtonLabel }: AdminFormProps) {
  const { errors } = usePage<{ errors: FormErrors }>().props;

  const form = useForm<AdminFormType>({
    mode: "uncontrolled",
    initialValues: {
      salutation: admin?.salutation,
      first_name: admin?.first_name,
      last_name: admin?.last_name,
      user_attributes: {
        email: admin?.user.email,
        password: "",
        active: admin?.user.active ?? true,
      },
    },
  });

  return (
    <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
      <Fieldset legend="Details">
        <Stack maw="60rem">
          <ParticularsForm form={form} errors={errors} />
          <UserForm form={form} errors={errors} />
          <Divider />
          <SaveButton label={submitButtonLabel} />
        </Stack>
      </Fieldset>
    </form>
  );
}
